import { PaginationType } from '@api';
import { getParamName } from '../../../../../../common';

type GetRecordsPerPageOptionsType = {
  pagination?: PaginationType;
  search: Record<string, unknown>;
  tableId?: string;
  defaultRecordsPerPage: number;
};

export const getRecordsPerPage = ({
  pagination,
  search,
  tableId,
  defaultRecordsPerPage,
}: GetRecordsPerPageOptionsType): number => {
  return (
    pagination?.pageSize ??
    (search?.[getParamName('pageSize', tableId)] as number | undefined) ??
    defaultRecordsPerPage
  );
};
